import React from "react";
import styled from "@emotion/styled";
import { baseWidths, colors } from "src/theme";
import { mediaQuery } from "src/common";
import { Flex } from "../grid";

const FlexStyle = styled(Flex)({
  height: 98,
  background: colors.white,
  position: 'sticky',
  bottom: 0,
  width: '100vw',
  marginTop: 24,
  marginBottom: -24,
  marginLeft: `-7%`,
  justifyContent: 'space-around',
  zIndex: 1,
  boxShadow: '0px 4px 40px 0px rgba(0, 0, 0, 0.06)',

  [mediaQuery('mobile')]: {
    justifyContent: 'center',
    gap: 300,
    marginBottom: -40,
    marginLeft: `calc(${baseWidths.mobile/2}px - 50vw)`,
  },
})

interface SuperFooterBarProps {
  children?: React.ReactNode;
}

export const SuperFooterBar: React.FC<SuperFooterBarProps> = ({ children }) => (
  <FlexStyle align="center">
    {children}
  </FlexStyle>
)


